require('./bootstrap');


window.addEventListener('online', () => {
    PNotify.removeAll()
});
window.addEventListener('offline', () => {
    new PNotify({
        title: 'İnternet Bağlantısı Yok!',
        text: 'Lütfen bağlantınızı kontrol edin.',
        icon: 'feather icon-alert-circle font-30',
        hide: false,
        buttons: {
            closer: false,
            sticker: false
        },
        history: {
            history: false
        }
    });
});


window.firebaseConfig = {
    apiKey: "AIzaSyB14tyE-MDwJafGvbOzh45be55FLHeCiV0",
    authDomain: "menupratic-4b323.firebaseapp.com",
    databaseURL: "https://menupratic-4b323.firebaseio.com",
    projectId: "menupratic-4b323",
    storageBucket: "menupratic-4b323.appspot.com",
    messagingSenderId: "897171629231",
    appId: "1:897171629231:web:19277b765f4f01718ee05a",
    measurementId: "G-JR5JK842F5"
};


window.itiConfig = {
    // allowDropdown: false,
    // autoHideDialCode: false,
    // autoPlaceholder: "off",
    // dropdownContainer: document.body,
    // excludeCountries: ["us"],
    // formatOnDisplay: true,

    // hiddenInput: "full_number",
    // localizedCountries: { 'de': 'Deutschland' },
    //nationalMode: true,
    initialCountry: "tr",
    geoIpLookup: function (success) {
        // Get your api-key at https://ipdata.co/
        fetch("https://api.ipdata.co/?api-key=52b41748bfb42db8372c5436b8b84c7247ec395d729feb7576c641c6")
            .then(function (response) {
                if (!response.ok) return success("");
                return response.json();
            })
            .then(function (ipdata) {
                success(ipdata.country_code);
            });
    },
    onlyCountries: ['tr', 'az', 'gb', 'de', 'us', 'sa', 'it', 'ae'],
    // placeholderNumberType: "MOBILE",
    preferredCountries: ['tr'],
    separateDialCode: true,

    utilsScript: "/js/utils.js",
}
